export default __webpack_public_path__ + "static/media/profile-shift.5d9763f5.svg";